
export default class UnexLib {
    constructor(options) {
        this.cache = [];

        this.url = options.url;

        this.init();

        this.active_filters = {};


        this.async = options.async === undefined ? false : options.async;
        var obj = this;
        var self = this;

        this.onError = typeof (options.onError) === "function" ? options.onError : function () { };
        this.onLoadEntity = typeof (options.onLoadEntity) === "function" ? options.onLoadEntity : function () { };
        this.onLoaded = typeof (options.onLoaded) === "function" ? options.onLoaded : function () { };
        this.onReforgeFilter = typeof (options.onReforgeFilter) === "function" ? options.onReforgeFilter.bind(this) : function () { };
        this.authenticated = false;
        this.loadedEntities = 0;
        this.totalEntities = 10;

        // TODO: saber d'on ve aixo
        this.selected_market_solutions = 0;
        this.selected_language = 'es';
        this.selected_language_solutions = 'es';

        this.markets = {};
        this.applications = {};
        this.assemblies = {};
        this.countries = {};
        this.provinces = {};
        this.sectors = {};
        this.themes = {};
        this.product_families = {};
        this.materials = {};
        this.interior = {
            0: { cl: 'Intemperie', de: 'Außenbereich', en: 'Outdoor', es: 'Intemperie', fr: 'Intempérie', it: 'Intemperie', pt: 'Exterior' },
            1: { cl: 'Interior', de: 'Innenbereich', en: 'Indoor', es: 'Interior', fr: 'Intérieur', it: 'Interno', pt: 'Interior' },
        };
        this.filter_history = [];

    }

    init() {

    }


    getRequest(url, headers, fnc, async, fncError) {
        var lib = this;
        var xhttp = new XMLHttpRequest();
        async = async === undefined ? true : async;
        headers = headers === undefined ? {} : headers;
        fncError = fncError === undefined ? function () { } : (typeof (fncError) === "function" ? fncError : function () { });

        xhttp.open("GET", url, async);
        xhttp.withCredentials = true;
        xhttp.setRequestHeader('Accept', 'application/json');
        for (var key in headers) {
            xhttp.setRequestHeader(key, headers[key]);
        }
        var onload = function () {
            response = {};

            if (xhttp.status === 200) {
                var response = JSON.parse(xhttp.response);
                lib.addCachedRequest(url, response);
                (fnc.bind(xhttp))(response);
            } else {
                if (lib.onError != undefined) lib.onError.call(xhttp);
                else fncError.call(xhttp);
            }
            return response;
        };

        if (async) xhttp.onload = onload;
        if (!async) {
            var result = lib.getCachedRequest(url);
            if (result !== false) {
                (fnc.bind(xhttp))(result);
                return result;
            }
        }
        xhttp.send();
        if (!async) return onload();
    }

    getUserData(fncError) {
        var obj = this;
        fncError = fncError === undefined ? function () { } : (typeof (fncError) === "function" ? fncError : function () { });
        return this.getRequest(obj.url + "/user", { Authorization: obj.bearer }, (function () { }), false, fncError);
    }

    setMarketSolutions(market, fncError) {
        fncError = fncError === undefined ? function () { } : (typeof (fncError) === "function" ? fncError : function () { });
        if (this.user.markets.indexOf(market) !== -1) {
            this.selected_market_solutions = market;
            return true;
        } else {
            return false;
        }
    }

    setDefaultLanguage(language, fncError) {
        fncError = fncError === undefined ? function () { } : (typeof (fncError) === "function" ? fncError : function () { });
        if (this.user.languages.indexOf(language) !== -1) {
            this.default_language = language;
            var user_data = this.getUserData(fncError);
            user_data['default_language'] = language;
            this.updateUserData(user_data, fncError);
            this.user.default_language = language;
            return true;
        } else {
            return false;
        }
    }

    setDefaultLanguageSolutions(language, fncError) {
        fncError = fncError === undefined ? function () { } : (typeof (fncError) === "function" ? fncError : function () { });
        if (this.user.languages.indexOf(language) !== -1) {
            this.default_language_solutions = language;
            var user_data = this.getUserData(fncError);
            user_data['default_language_solutions'] = language;
            this.updateUserData(user_data, fncError);
            this.user.default_language_solutions = language;
            return true;
        } else {
            return false;
        }
    }

    setDefaultMarketSolutions(market, fncError) {
        fncError = fncError === undefined ? function () { } : (typeof (fncError) === "function" ? fncError : function () { });
        if (this.user.markets.indexOf(market) !== -1) {
            this.default_market = market;
            var user_data = this.getUserData(fncError);
            user_data['default_market'] = market;
            this.updateUserData(user_data, fncError);
            this.user.default_market = market;
            return true;
        } else {
            return false;
        }
    }

    setLanguage(language, fncError) {
        fncError = fncError === undefined ? function () { } : (typeof (fncError) === "function" ? fncError : function () { });
        if (this.user.languages.indexOf(language) !== -1) {
            this.selected_language = language;
            return true;
        } else {
            return false;
        }
    }

    setLanguageSolutions(language, fncError) {
        fncError = fncError === undefined ? function () { } : (typeof (fncError) === "function" ? fncError : function () { });
        console.warn(this.user.languages_solutions)
        if (this.user.languages_solutions.indexOf(language) !== -1) {
            this.selected_language_solutions = language;
            return true;
        } else {
            return false;
        }
    }

    getStoredQueries(id_market, fncError) {
        return []
        fncError = fncError === undefined ? function () { } : (typeof (fncError) === "function" ? fncError : function () { });
        return this.getRequest(this.url + "/queries-list?id_market=" + id_market + "&market_query=false",
            {
                // Authorization: this.bearer
            }, (function () { }), false, fncError);
    }

    getStoredMarketQueries(id_market, fncError) {
        return []
        fncError = fncError === undefined ? function () { } : (typeof (fncError) === "function" ? fncError : function () { });
        return this.getRequest(this.url + "/queries-list?id_market=" + id_market + "&market_query=true",
            {
                // Authorization: this.bearer
            }, (function () { }), false, fncError);
    }

    storeQuery(query_data, fncError) {
        fncError = fncError === undefined ? function () { } : (typeof (fncError) === "function" ? fncError : function () { });
        return this.postRequest(
            this.url + "/queries-store",
            query_data,
            {
                Authorization: this.bearer,
                Accept: "application/json",
                "Content-Type": "application/json"
            },
            (function () { }),
            false,
            fncError);
    }

    deleteQuery(id_query, fncError) {
        fncError = fncError === undefined ? function () { } : (typeof (fncError) === "function" ? fncError : function () { });
        return this.getRequest(this.url + "/query-delete/" + id_query, { Authorization: this.bearer }, (function () { }), false, fncError);
    }






    buildHistory(filh) {
        if (typeof (filh) === "undefined") {
            filh = this.filter_history;
        }
        var return_obj = { market: this.selected_market_solutions, language: this.selected_language_solutions };
        for (var fh in filh) {
            var value = filh[fh];
            var key = Object.keys(value)[0];
            var vl = value[key];
            if (return_obj[key] === undefined) return_obj[key] = [];
            return_obj[key].push(vl);
        }
        return return_obj;
    }

    is_present_in_history(new_key, new_value) {
        var found = false;
        for (var fh in this.filter_history) {
            var value = this.filter_history[fh];
            var key = Object.keys(value)[0];
            var vl = value[key];
            if (key === new_key && vl === new_value) found = true;
        }
        return found;
    }

    addToHistory(new_key, new_value) {
        if (!this.is_present_in_history(new_key, new_value)) {
            var nv = new Object();
            nv[new_key] = new_value;
            this.filter_history.push(nv);
        }
    }

    deleteFromHistory(new_key, new_value) {
        for (var fh in this.filter_history) {
            var value = this.filter_history[fh];
            var key = Object.keys(value)[0];
            var vl = value[key];
            if (key === new_key && vl === new_value) delete this.filter_history[fh];
        }
    }

    updateFilterHistory(data) {
        for (var fh in this.filter_history) {
            var value = this.filter_history[fh];
            var key = Object.keys(value)[0];
            var vl = value[key];
            if (!(typeof (data[key]) === "object" && data[key].indexOf(vl) !== -1)) {
                this.deleteFromHistory(key, vl);
            }
        }
        for (var fh1 in data) {
            if (fh1 !== 'market' && fh1 !== 'language') {
                for (var i in data[fh1]) {
                    this.addToHistory(fh1, data[fh1][i]);
                }
            }
        }
    }



}